export { default } from './offers-tab';
